import React from 'react';
import { useSelector } from 'react-redux';

const About = () => {
  const company = useSelector((state) => state.companyReducer.company);
  const description = company.description || "Description not available";
  const cleanDescription = description.replace(/<[^>]*>/g, "");

  return (
    <section className="py-24 relative bg-[rgb(8,64,88)] text-white">
      <div className="w-full max-w-full px-4 md:px-5 lg:px-5 mx-auto">
        <div className="w-full flex justify-between items-center gap-4"> {/* Used flex for equal height */}

          {/* Image on the left and content on the right */}
          <div className="flex flex-col justify-center items-start pr-4 w-full lg:w-[50%]"> {/* Adjusted width to ensure equal split */}
            <img className="lg:w-[600px] w-[500px] h-[400px] object-cover rounded-3xl" src="https://pagedone.io/asset/uploads/1717751272.png" alt="About us" />
          </div>

          {/* Content on the right */}
          <div className="flex flex-col justify-center items-start pl-4 w-full lg:w-[50%]"> {/* Adjusted width to ensure equal split */}
            <div className="w-full flex-col justify-start gap-4">
              <h2 className="text-white text-4xl font-bold font-manrope leading-normal text-left">
                Building Stronger Communities through Collaboration and Empowerment
              </h2>
              <br />
              <p className="text-white text-base font-normal leading-relaxed text-left">
                {cleanDescription}
              </p>
            </div>
            <button className="sm:w-fit w-full px-3.5 py-2 bg-white hover:bg-transparent text-[rgb(8,64,88)] transition-all duration-700 ease-in-out rounded-lg shadow-[0px_1px_2px_0px_rgba(16,_24,_40,_0.05)] justify-center items-center flex mt-4">
              <span className="px-1.5 text-[rgb(8,64,88)] text-sm font-medium leading-6">Get Started</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
